/*
 * There is no login yet -- the directory is entirely public reads plus one
 * unauthenticated POST. This exists so the api middleware has a single place to
 * ask for a token when the claims module lands, rather than growing an auth
 * branch through every request class at that point.
 *
 * localStorage throws outright in a locked-down browser, so every access is
 * wrapped; a thrown read here would take down the whole request pipeline.
 */
const KEY = 'lbi.access_token';

const TokenStorage = {
  getAccessToken() {
    try {
      return window.localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  },

  setToken(token) {
    try {
      // Reads .access_token off its argument. Handing it the bare string writes
      // the literal "undefined", which reads back as a truthy token and sends
      // "Bearer undefined" on every request.
      window.localStorage.setItem(KEY, token.access_token);
    } catch (e) {
      /* private window, blocked site data -- carry on unauthenticated */
    }
  },

  clear() {
    try {
      window.localStorage.removeItem(KEY);
    } catch (e) {
      /* nothing to do */
    }
  },
};

export default TokenStorage;
